var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestinationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 29,
    viewBox: "0 0 16 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.77454,
    cy: 23.5,
    r: 5,
    fill: "white",
    stroke: "#1D2B36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64707 0C3.43056 0 0 3.58889 0 8.00002C0 9.32423 0.316472 10.6372 0.918095 11.8018L7.22889 23.7422C7.3129 23.9014 7.473 24 7.64707 24C7.82115 24 7.98124 23.9014 8.06526 23.7422L14.3784 11.7978C14.9777 10.6372 15.2941 9.32419 15.2941 7.99997C15.2941 3.58889 11.8636 0 7.64707 0ZM7.64707 12C5.53882 12 3.82356 10.2056 3.82356 8.00002C3.82356 5.79445 5.53882 4.00003 7.64707 4.00003C9.75533 4.00003 11.4706 5.79445 11.4706 8.00002C11.4706 10.2056 9.75533 12 7.64707 12Z",
    fill: "#E91D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationMarker);
export default __webpack_public_path__ + "static/media/destination-marker.589672cdc7af2701022bc376b5c5013f.svg";
export { ForwardRef as ReactComponent };